export default __webpack_public_path__ + "static/media/icon-ic-pickup.d6550dd1.svg";